<div class="dc-wave wave-1" [class.playing]="isTyping"></div>
<div class="dc-wave wave-2" [class.playing]="isTyping"></div>
<div class="dc-wave wave-3" [class.playing]="isTyping"></div>
<div class="dc-wave wave-4" [class.playing]="isTyping"></div>
